var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObjectiveC(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f1592a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8",
    className: "cls-1",
    d: "m49.86,99.5C23.27,99.5.71,77.03.5,50.27c-.09-13.04,5.04-25.58,14.25-34.81C24.03,5.95,36.72.57,49.99.5h0c13.03-.01,25.53,5.18,34.72,14.42,9.34,9.11,14.67,21.57,14.78,34.62.12,27.36-21.87,49.68-49.23,49.96h-.4Zm.16-96.41c-12.58.07-24.6,5.18-33.39,14.19C7.89,26.01,3.02,37.88,3.09,50.24c.19,25.37,21.57,46.64,46.76,46.64h.34c25.94-.24,46.82-21.39,46.72-47.33-.12-12.36-5.16-24.17-14.02-32.79C74.2,7.99,62.36,3.07,50.02,3.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    className: "cls-1",
    d: "m11.6,64.48v-28.92h7.04v2.59h-3.73v23.79h3.73v2.59l-7.04-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12",
    className: "cls-1",
    d: "m35.48,49.73c0,5.27-3.2,8.28-7.54,8.28s-7.23-3.38-7.23-8.01,3.03-8.24,7.46-8.24,7.31,3.55,7.31,7.97Zm-11.74.23c0,3.2,1.61,5.74,4.37,5.74s4.34-2.59,4.34-5.86c0-2.97-1.46-5.77-4.34-5.77s-4.39,2.71-4.39,5.95l.03-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    className: "cls-1",
    d: "m37.92,42.31c1.38-.24,2.77-.35,4.17-.35,1.57-.15,3.15.2,4.51,1,1.04.61,1.66,1.74,1.63,2.94-.04,1.58-1.08,2.95-2.59,3.41h0c1.85.38,3.18,2,3.17,3.89.02,1.26-.54,2.45-1.52,3.24-1.11.98-2.97,1.46-5.83,1.46-1.18,0-2.35-.06-3.52-.21l-.03-15.38Zm2.85,6.21h1.46c1.98,0,3.1-.93,3.1-2.27s-1.11-2.15-2.94-2.15c-.55-.02-1.09.02-1.63.12v4.3Zm.01,7.23c.5.05,1.01.07,1.52.06,1.84,0,3.47-.7,3.47-2.59s-1.58-2.59-3.56-2.59h-1.43v5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    className: "cls-1",
    d: "m54.48,42.1h2.86v10.22c0,4.34-2.1,5.79-5.18,5.79-.82,0-1.64-.15-2.42-.41l.35-2.31c.57.18,1.17.28,1.77.29,1.63,0,2.59-.75,2.59-3.47l.03-10.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    className: "cls-1",
    d: "m65.49,50.62v1.98h-5.96v-1.98h5.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    className: "cls-1",
    d: "m79.4,57.35c-1.29.51-2.67.75-4.06.7-4.99,0-8.02-3.12-8.02-7.9-.23-4.36,3.12-8.08,7.47-8.31.31-.02.61-.01.92,0,1.33-.06,2.66.18,3.89.7l-.63,2.28c-.97-.41-2.02-.62-3.08-.61-3.2,0-5.51,2.01-5.51,5.79,0,3.45,2.03,5.67,5.48,5.67,1.07.02,2.13-.18,3.12-.58l.41,2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    className: "cls-1",
    d: "m88.4,35.48v29h-7.04v-2.59h3.73v-23.81h-3.73v-2.59h7.04Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectiveC);
export default __webpack_public_path__ + "static/media/objective-c.dce066b3ee2b1bba6be9659f1aac1a43.svg";
export { ForwardRef as ReactComponent };